export const EllipseDot = ({ className }) => (
  <div className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width="3" height="4" viewBox="0 0 3 4" fill="none">
      <circle opacity="0.32" cx="1.5" cy="2" r="1.5" fill="#262626" />
    </svg>
  </div>
);
